import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Generate or get session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('visitor_session_id');
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('visitor_session_id', sessionId);
  }
  return sessionId;
};

// Track page visit
export const trackPageVisit = async (page = window.location.pathname) => {
  try {
    const sessionId = getSessionId();
    
    await axios.post(`${BACKEND_URL}/api/track-visitor`, {
      sessionId,
      page,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString()
    });
  } catch (error) {
    // Silently fail - don't disrupt user experience
    console.debug('Visitor tracking failed:', error);
  }
};

// Initialize tracking
export const initVisitorTracking = () => {
  // Track initial page load
  trackPageVisit();
  
  // Track subsequent page changes (for single-page apps)
  let lastPath = window.location.pathname;
  setInterval(() => {
    const currentPath = window.location.pathname;
    if (currentPath !== lastPath) {
      lastPath = currentPath;
      trackPageVisit(currentPath);
    }
  }, 2000);
};
